import Link from 'next/link';
import React from 'react';

export type AlertButtonPropsInterface = {
    href?: string;
    children: React.ReactNode;
    onClick?: (event: React.MouseEvent<HTMLSpanElement>) => void;
};

export const AlertButton: React.FC<AlertButtonPropsInterface> = ({ href, children, onClick }) => {
    const buttonContent = <span>{children}</span>;

    if (!href) {
        return <a onClick={onClick}>{buttonContent}</a>;
    }

    return (
        <Link href={href} passHref>
            <a>{buttonContent}</a>
        </Link>
    );
};
